import { createSlice } from "@reduxjs/toolkit";
import {
  addTeacherForSchool,
  deleteTeacher,
  editTeachers,
  getTeachersForSchool,
  addSessionsForTeacher,
  getSessionsForTeacher,
} from "../services/teacher_service";
// ----------------------------------------------------------------------

const slice = createSlice({
  name: "teacher",
  initialState: {
    isLoadingGetTeachersForSchool: false,
    isLoadingAddTeacherForSchool: false,
    isLoadingDeleteTeacher: false,
    allSchoolTeachersInfo: {},
    isLoadingEditTeacher: false,
    selectedTeacher: {},
    teacherPageNumber: 1,
    isLoadingAddTeacherSessionsTeacher: false,
    isLoadingAllSessions: false,
    sessions: [],
  },

  reducers: {
    setSelectedTeacher: (state, action) => {
      state.selectedTeacher = action.payload;
    },
    setTeacherPageNumber: (state, action) => {
      state.teacherPageNumber = action.payload;
    },
  },

  extraReducers: {
    // ==> get TeachersForSchool
    [getTeachersForSchool.fulfilled]: (state, action) => {
      state.isLoadingGetTeachersForSchool = false;
      state.allSchoolTeachersInfo = action.payload.data;
    },
    [getTeachersForSchool.rejected]: (state, action) => {
      state.isLoadingGetTeachersForSchool = false;
    },
    [getTeachersForSchool.pending]: (state) => {
      state.isLoadingGetTeachersForSchool = true;
    },

    // ==> Add TeachersForSchool
    [addTeacherForSchool.fulfilled]: (state, action) => {
      state.isLoadingAddTeacherForSchool = false;
    },
    [addTeacherForSchool.rejected]: (state, action) => {
      state.isLoadingAddTeacherForSchool = false;
    },
    [addTeacherForSchool.pending]: (state) => {
      state.isLoadingAddTeacherForSchool = true;
    },

    // ==> Add TeachersSessions
    [addSessionsForTeacher.fulfilled]: (state, action) => {
      state.isLoadingAddTeacherSessionsTeacher = false;
    },
    [addSessionsForTeacher.rejected]: (state, action) => {
      state.isLoadingAddTeacherSessionsTeacher = false;
    },
    [addSessionsForTeacher.pending]: (state) => {
      state.isLoadingAddTeacherSessionsTeacher = true;
    },

    // ==> Delete TeachersForSchool
    [deleteTeacher.fulfilled]: (state, action) => {
      state.isLoadingDeleteTeacher = false;
      if (
        action.response.message === "Deleted Successfully" ||
        action.response.message === "تم الحذف بنجاح"
      ) {
        window.location.reload();
      }
    },
    [deleteTeacher.rejected]: (state, action) => {
      state.isLoadingDeleteTeacher = false;
    },
    [deleteTeacher.pending]: (state) => {
      state.isLoadingDeleteTeacher = true;
    },

    // ==>editTeachers
    [editTeachers.fulfilled]: (state, action) => {
      state.isLoadingEditTeacher = false;
      // if (action.response.message === 'Deleted Successfully'
      //   || action.response.message === 'تم الحذف بنجاح'
      // ) {
      //   window.location.reload();
      // }
    },
    [editTeachers.rejected]: (state, action) => {
      state.isLoadingEditTeacher = false;
    },
    [editTeachers.pending]: (state) => {
      state.isLoadingEditTeacher = true;
    },

    //GET  ==>  get teacher Sessions
    [getSessionsForTeacher.fulfilled]: (state, action) => {
      state.isLoadingAllSessions = false;
      console.log("fullfield");
      console.log(action.payload.data);

      state.sessions = action.payload.data;
      console.log(state.sessions);
    },
    [getSessionsForTeacher.rejected]: (state, action) => {
      state.isLoadingAllSessions = false;
    },
    [getSessionsForTeacher.pending]: (state) => {
      state.isLoadingAllSessions = true;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setSelectedTeacher, setTeacherPageNumber } = slice.actions;
